import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useCookieConsent } from "@/components/CookieConsentContext";
import { WA_CONSULTATION } from "@/lib/api";

export default function FloatingWhatsApp() {
  const { pathname } = useLocation();
  const { hasChoice } = useCookieConsent();
  const hideFloatingButton = pathname.startsWith("/pack/planificador/") || pathname === "/taller-rabietas-2-3";
  const aboveStickyCta = pathname === "/";
  const position = hasChoice
    ? aboveStickyCta ? "bottom-24 md:bottom-6" : "bottom-4 md:bottom-6"
    : "bottom-[17rem] md:bottom-40";

  if (hideFloatingButton) return null;

  return (
    <a
      href={WA_CONSULTATION}
      target="_blank"
      rel="noreferrer"
      aria-label="¿Tienes dudas antes de comprar? Escríbenos por WhatsApp"
      title="¿Tienes dudas? Escríbenos por WhatsApp"
      data-testid="floating-whatsapp-link"
      className={`fixed right-4 z-[70] flex size-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 hover:bg-[#20bd5a] focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-4 focus-visible:outline-[#128C7E] ${position}`}
    >
      <MessageCircle size={27} strokeWidth={2.5} aria-hidden="true" />
    </a>
  );
}